import * as React from 'react';
import { Box, CircularProgress, LinearProgress } from '@mui/material';
import { useAppSelector } from '../state/hooks';

/** A thin bar across the top of the window, above the header. */
export function TopProgressBar() {
  return (
    <LinearProgress
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar + 1,
      }}
    />
  );
}

/** Shows the bar while something has set the global loader flag (e.g. signing out). */
export function Loader() {
  const isLoading = useAppSelector((state) => state.loader.loaderValue);
  return isLoading ? <TopProgressBar /> : null;
}

/** Shown while a page's code downloads: a page that is plainly loading, not one gone blank. */
export function PageLoading() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 8 }}>
      <CircularProgress size={32} sx={{ color: 'var(--accent)' }} />
      <Box sx={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--muted)' }}>
        Wczytywanie strony…
      </Box>
    </Box>
  );
}
